import { useSnackbar, ProviderContext } from "notistack";

// notificationHelper.js
let useSnackbarRef: ProviderContext;
export const SnackbarUtilsConfigurator = () => {
    useSnackbarRef = useSnackbar();
    return null;
};

type Variant = "default" | "error" | "success" | "warning" | "info";

const SnackbarUtils = {
    success(msg: string) {
        this.toast(msg, "success");
    },
    error(msg: string) {
        this.toast(msg, "error");
    },
    info(msg: string) {
        this.toast(msg, "info");
    },
    warning(msg: string) {
        this.toast(msg, "warning");
    },
    toast(msg: string, variant: Variant = "default") {
        useSnackbarRef?.enqueueSnackbar(msg, { variant });
    },
};

export default SnackbarUtils;
